/* Numiere theme JS
   Cart drawer, add-to-cart via /cart/add.js, variant picker, small helpers.
   ------------------------------------------------------------------ */

(function () {
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var moneyFmt = window.Shopify && Shopify.currency ? Shopify.currency : { active: 'USD' };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ---------- Cart drawer open/close ----------
  var drawer = $('[data-cart-drawer]');
  function openCart()  { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); refreshCart(); } }
  function closeCart() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); } }
  $$('[data-cart-toggle]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  // ---------- Fetch and render cart ----------
  function refreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  window.numiereRefreshCart = refreshCart;

  function renderCart(cart) {
    var body = $('[data-cart-body]');
    var footer = $('[data-cart-footer]');
    var count = $('[data-cart-count]');
    if (count) { count.textContent = cart.item_count; count.setAttribute('data-cart-count', cart.item_count); }

    if (!body || !footer) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your bag is empty.</p><a href="/collections/featured" class="btn btn--primary">Shop bestsellers</a></div>';
      footer.hidden = true;
      return;
    }

    var html = cart.items.map(function (item) {
      return '<div class="cart-drawer__item">' +
        (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '<span></span>') +
        '<div class="cart-drawer__item-info">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<span class="cart-drawer__item-variant">' + item.variant_title + '</span>' : '') +
          '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
          '<div class="cart-drawer__item-qty">' +
            '<button type="button" data-cart-decrement data-key="' + item.key + '" data-qty="' + item.quantity + '">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-cart-increment data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
          '</div>' +
          '<button type="button" class="cart-drawer__item-remove" data-cart-remove data-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
    body.innerHTML = html;

    footer.hidden = false;
    $('[data-cart-subtotal]').textContent = formatMoney(cart.total_price);

    // Wire quantity buttons
    $$('[data-cart-increment]', body).forEach(function (b) { b.addEventListener('click', function () { updateItem(b.dataset.key, parseInt(b.dataset.qty,10) + 1); }); });
    $$('[data-cart-decrement]', body).forEach(function (b) { b.addEventListener('click', function () { updateItem(b.dataset.key, Math.max(0, parseInt(b.dataset.qty,10) - 1)); }); });
    $$('[data-cart-remove]', body).forEach(function (b) { b.addEventListener('click', function () { updateItem(b.dataset.key, 0); }); });
  }

  function updateItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  // ---------- Add-to-cart form intercept ----------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var originalLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (btn) { btn.textContent = res.data.description || 'Sorry, try again'; setTimeout(function () { btn.disabled = false; btn.textContent = originalLabel; }, 2500); }
          return;
        }
        // Fire analytics event
        if (window.numiereTrack) {
          window.numiereTrack('add_to_cart', {
            item_id: res.data.product_id, item_name: res.data.product_title,
            variant: res.data.variant_title, quantity: res.data.quantity,
            value: (res.data.final_line_price || 0) / 100, currency: moneyFmt.active || 'USD'
          });
        }
        try { if (window.fbq) window.fbq('track', 'AddToCart', { content_ids: [res.data.product_id], content_name: res.data.product_title, value: (res.data.final_line_price || 0) / 100, currency: 'USD' }); } catch (e) {}
        try { if (window.ttq) window.ttq.track('AddToCart', { content_id: String(res.data.product_id), content_name: res.data.product_title, value: (res.data.final_line_price || 0) / 100, currency: 'USD' }); } catch (e) {}

        if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.disabled = false; btn.textContent = originalLabel; }, 1200); }
        openCart();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
      });
  });

  // ---------- PDP variant picker ----------
  $$('[data-variant-picker]').forEach(function (root) {
    var variantsScript = root.querySelector('[data-variants-json]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var priceEl   = root.querySelector('[data-variant-price]');
    var compareEl = root.querySelector('[data-variant-compare]');
    var idInput   = root.querySelector('input[name="id"]');
    var addBtn    = root.querySelector('[data-add-btn]');

    function update() {
      var selected = getSelected(root);
      var v = matchVariant(variants, selected);
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
      }
    }
    function getSelected(r) {
      return $$('[data-variant-option]', r).map(function (o) {
        var checked = o.querySelector(':checked');
        return checked ? checked.value : null;
      });
    }
    function matchVariant(vs, sel) {
      return vs.find(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); });
    }
    $$('input', root).forEach(function (i) { i.addEventListener('change', update); });
    update();
  });

  // ---------- PDP gallery ----------
  $$('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    $$('[data-gallery-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) main.src = t.dataset.full;
        $$('[data-gallery-thumb]', g).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  // ---------- Initial cart count fetch ----------
  if (document.readyState !== 'loading') refreshCart();
  else document.addEventListener('DOMContentLoaded', refreshCart);
})();
